namespace GeniuzPOS.ReportMasterData {
    export class Report_1309Columns {
        static columnsKey = 'ReportMasterData.Report_1309';
    }
}
